<template>
    <section class="flex flex-col flex-1">
        <div class="flex flex-col lg:flex-row lg:items-center">
            <div class="flex-1 mr-2">
                <h1 class="text-2xl font-bold test-gray-700">DEP's Private Building Inventory</h1>
                <p class="text-gray-700 font-semibold mt-2">
                    DEP's private building inventory contains the Montgomery County Building ID and best-known building gross square footage, both of which will be needed to benchmark your building. Each building must confirm their own building square footage to determine coverage under the law. Other information, such as building name and use type, is provided for context based on latest available records at the time of publishing. If you can't find your building here, reach out to DEP (<a href="mailto:energy@montgomerycountymd.gov" class="text-blue underline">energy@montgomerycountymd.gov</a>) to confirm your building coverage.
                </p>
            </div>
            <div class="mt-4 lg:mt-0">
                <base-button @click="onClickDownload" color="blue">
                    <download-icon class="h-5 w-5 mr-2" />
                        Export
                </base-button>
            </div>
        </div>
        <view-errors :error="error"></view-errors>
        <div class="w-full md:w-1/2 lg:w-1/3 mt-4">
            <form-group>
                <form-label for="search_buildings" class="sr-only">Search Building by MBID, Building Name or Address</form-label>
                <text-input id="search_buildings" class="block w-full" placeholder="Search Building by MBID, Building Name or Address" v-model="search"/>
            </form-group>
        </div>
        <card-container spacing="lg" class="w-full mt-4 overflow-hidden">
            <div class="-mx-6 -mt-4">
                <div class="grid grid-cols-1">
                    <base-table
                        class="report-table"
                        :search="search"
                        :data="buildings"
                        :columns="columns"
                        :loading="loading"
                        :searchKeys="['custom_building_id', 'street', 'city', 'postal_code', 'building_name']"
                        paginated
                        custom-row-class="odd:bg-blue-50 even:bg-blue-100"
                        >
                        <template v-slot="{ row }">
                            <td>
                                {{ row.benchmarking_group | empty_string_format }}
                            </td>
                            <td>
                                {{ row.custom_building_id }}
                            </td>
                            <td>
                                {{ row.street }}
                            </td>
                            <td>
                                {{ row.city }}
                            </td>
                            <td>
                                {{ row.postal_code }}
                            </td>
                            <td>
                                {{ row.gross_floor_area | number_format }}
                            </td>
                            <td>
                                {{ row.gfa_reported | number_format }}
                            </td>
                            <td>
                                {{ row.building_name | empty_string_format }}
                            </td>
                            <td>
                                {{ row.primary_use_type | empty_string_format }}
                            </td>
                            <td>
                                {{ row.reporting_start_year }}
                            </td>
                        </template>
                    </base-table>
                </div>
            </div>
        </card-container>
    </section>
</template>
<script>
import ApiService from '@/services/apiService';
import { ViewErrorsMixin, DownloadIcon } from '@touchstone/touchstone-assets';

export default {
    mixins: [ViewErrorsMixin],
    components: {
        DownloadIcon
    },
    data() {
        const srv = new ApiService();
        return {
            loading: true,
            api: srv.buildingsApi(),
            buildings: [],
            columns: [
                { label: 'Benchmarking Group', field: 'benchmarking_group', sortable: true },
                { label: 'Montgomery County Building ID', field: 'custom_building_id', sortable: true },
                { label: 'Street', field: 'street', sortable: true },
                { label: 'City', field: 'city', sortable: true },
                { label: 'Postal Code', field: 'postal_code', sortable: true },
                { label: 'Assessor GFA (sq-ft)', field: 'gross_floor_area', sortable: true },
                { label: 'Reported GFA (sq-ft)', field: 'gfa_reported', sortable: true },
                { label: 'Building Name', field: 'building_name', sortable: true },
                { label: 'Use Type', field: 'primary_use_type', sortable: true },
                { label: 'Reporting Start Year', field: 'reporting_start_year', sortable: true },
            ],
            search: ''
        };
    },

    created() {
        this.getBuildings();
    },

    methods: {
        async getBuildings() {
            try {
                const { data } = await this.api.inventory();
                this.buildings = data;
            } catch (e) {
                this.setError(e);
            }
            this.loading = false;
        },
        onClickDownload() {
            window.open(this.api.downloadUrl(), '_blank');
        },
    }

};

</script>
